import { ApprovalStatus } from "@/services/api/contracts/companies";

export const getCustomerStatus = (status: ApprovalStatus) => {
  switch (status) {
    case ApprovalStatus.Pending:
      return 'Pending approval';
    case ApprovalStatus.InviteApproved:
      return 'Invitation approved';
    case ApprovalStatus.Not:
      return 'Not approved';
    case ApprovalStatus.View:
      return 'Approved to view';
    case ApprovalStatus.Capital:
      return 'Approved for capital';
    case ApprovalStatus.Full:
      return 'Approved for full access';
  }
};